import _ from 'lodash';

// all attributes must be defined as optional as we not set all (and delete them)
import {
    TREE_SET_TEMPDATA
} from '~/frontend/src/constants';
import {AnyAction} from 'redux';
import Item from '~/shared/src/ci/Item';
import Reference from '~/shared/src/ci/Reference';

export type TreeViewTempData = {
    metaData : string[];
    data : string;
}

type TreeViewState = Partial<{
    schema : Schema;

    // reset to defaults
    status : Status;
    timezone : string;
    timestamp : string;
    itemTypeName : string;
    searchString : string;

    tempData : any;
}>

const relevantActions = [
    TREE_SET_TEMPDATA
];

function extractData( state : TreeViewState, data : any, rootKey : string, panelKey : string ) {
    const schema : Schema = rootKey === 'metaData'
        ? 'CFG'
        : 'DATA';

    panelKey += rootKey === 'metaData'
        ? '-meta'
        : '';

    for ( const dataKey in data ) {
        let value = data[ dataKey ];

        if ( [ 'items', 'references' ].includes( dataKey ) ) {
            _.forOwn( value, obj => {
                if ( dataKey === 'items' ) {
                    new Item( obj, panelKey, schema );
                }
                else {
                    new Reference( obj, panelKey, schema );
                }

            } );
            value = Object.keys( value );
        }
        if (
            !Object.keys( state.tempData[ rootKey ] ).includes( dataKey )
            || JSON.stringify( state.tempData[ rootKey ][ dataKey ] ) !== value
        ) {
            state.tempData[ rootKey ][ dataKey ] = value;
        }
    }
}

export default function treeViewReducer( state : TreeViewState = {} as TreeViewState, action : AnyAction ) : TreeViewState {
    // create new state object (nested objects are kept)
    if ( relevantActions.includes( action.type ) ) {

        // copy current (stay immutable!)
        state = Object.assign( {}, state );
        const { panelKey } = action;

        switch ( action.type ) {

            case TREE_SET_TEMPDATA:
                if ( !state.tempData ) {
                    state.tempData = {
                        data    : {},
                        metaData: {}
                    };
                }
                else {
                    state.tempData = Object.assign( {}, state.tempData );
                }

                extractData( state, action.data[ 'data' ], 'data', panelKey );
                extractData( state, action.data[ 'metaData' ], 'metaData', panelKey );

                break;
        }

    }
    return state;
}
